"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import Navbar from "@/components/layout/Navbar";
import Button from "@/components/ui/Button";
import { useAnalyseStore } from "@/store/analyseStore";
import { useAuth } from "@/hooks/useAuth";

export default function WillkommenPage() {
  const router = useRouter();
  const { setPlan } = useAnalyseStore();
  const { isAuthenticated, isExpert, isLoading } = useAuth();

  // Wenn eingeloggt: Plan automatisch aus Keycloak-Rolle setzen
  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated && isExpert) {
      setPlan("expert");
    } else if (isAuthenticated) {
      setPlan("basis"); // eingeloggt aber kein Expert → basis
    }
  }, [isLoading, isAuthenticated, isExpert]);

  function handleWeiter() {
    router.push("/tool/allgemeine-daten");
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-xl w-full bg-gray-50 rounded-xl border border-gray-200 p-10 flex flex-col items-center gap-6 text-center">

          <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center">
            <span className="text-white text-lg font-bold">B</span>
          </div>

          <div className="flex flex-col gap-2">
            <h1 className="text-2xl font-bold text-gray-900">
              Willkommen bei BMM Kompakt
            </h1>
            <p className="text-sm text-gray-500 leading-relaxed">
              Dieses Tool analysiert die betriebliche Mobilität und zeigt
              Maßnahmen zur Verbesserung. Starten Sie mit der Eingabe der
              Unternehmensdaten.
            </p>
          </div>

          {/* Plan-Auswahl – nur für nicht eingeloggte User */}
          {!isAuthenticated && (
            <div className="w-full rounded-lg border-2 border-gray-200 bg-white px-4 py-3 text-center">
              <div className="font-semibold text-sm text-gray-700">Basic</div>
              <div className="text-xs text-gray-500 mt-0.5">
                Kostenlos starten – für Expert bitte anmelden
              </div>
            </div>
          )}

          {/* Eingeloggt – Plan anzeigen */}
          {isAuthenticated && (
            <div className={`
              w-full rounded-lg border-2 px-4 py-3 text-center
              ${isExpert
                ? "border-blue-600 bg-blue-50 text-blue-700"
                : "border-gray-200 bg-white text-gray-600"
              }
            `}>
              <div className="font-semibold text-sm">
                {isExpert ? "Expert" : "Basic"}
              </div>
              <div className="text-xs opacity-75 mt-0.5">
                {isExpert ? "Erweiterte Analyse" : "Kostenlos starten"}
              </div>
            </div>
          )}

          <Button size="lg" onClick={handleWeiter} className="w-40">
            Weiter
          </Button>

        </div>
      </main>
    </div>
  );
}